import { useShadow, useShadowStyle } from "../wcUtil.ts"
import styleText from './shared-modal-styles.css?raw';

export class AsModalClickthruDemo extends HTMLElement{
  static get observedAttributes(): string[] {
    return ['url'];
  }

  get url(){
    return this.getAttribute('url') || '';
  }

  get html(){
    return  /*html*/`
        <style>
          :host {
            width: 80vw !important;
            max-width: 80vw !important;
          }

          .panel-content {
            width: 100% !important;
          }

          .clickthru-iframe-container {
            width: 100%;
            height: 80vh;
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .clickthru-iframe {
            width: 100%;
            height: 100%;
            border: none;
            border-radius: 8px;
          }

          .close-button-row {
            display: flex;
            justify-content: flex-end;
            gap: 1rem;
          }

          .gray-button {
            --text-btn-bg-col: #e0e0e0;
            --text-btn-hover-bg-col: #bdbdbd;
            --text-btn-text-col: #424242;
            --text-btn-hover-text-col: #212121;
          }

          /* Apply the CSS rule to hide other elements in the iframe */
          :host ::slotted(.flex.flex-col.w-full.relative.shrink-0) > :not(#mainContainer) {
            display: none;
          }
        </style>
        <div id="clickthru-panel" class="panel-content">
          <div class="clickthru-iframe-container">
            ${this.url ? `<iframe class="clickthru-iframe" src="${this.url}" allow="fullscreen"></iframe>` : '<p>No URL provided for clickthrough demo</p>'}
            <div class="close-button-row">
              <as-text-button class="gray-button" name="open-clickthru-new-tab">Open in new tab</as-text-button>
              <as-text-button name="close-clickthru-modal">Close</as-text-button>
            </div>
          </div>
        </div>
    `
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'url' && oldValue !== newValue && this.shadowRoot) {
      const iframe = this.shadowRoot.querySelector('.clickthru-iframe') as HTMLIFrameElement;
      const container = this.shadowRoot.querySelector('.clickthru-iframe-container') as HTMLElement;

      if (newValue) {
        if (iframe) {
          iframe.src = newValue;
        } else if (container) {
          // If no iframe exists, recreate the container content
          const closeButton = container.querySelector('.close-button-row');
          container.innerHTML = `<iframe class="clickthru-iframe" src="${newValue}" allow="fullscreen"></iframe>`;
          if (closeButton) {
            container.appendChild(closeButton);
          }
        }
      }
    }
  }

  connectedCallback(){
    useShadow(this, this.html)
    useShadowStyle(this, styleText, './shared-modal-styles.css')
  }
}

customElements.define("as-modal-clickthru-demo", AsModalClickthruDemo)
